<template>
    <div :class="$style['tools']" class="prevent-close">
        <div :class="$style['tools__row']">
            <BaseToolsSearch
                :class="$style['tools__search']"
                @submit="onSearchSubmit"
                placeholder="Поиск"
                v-model="localSearch"
            ></BaseToolsSearch>
        </div>

        <BaseToolsSort
            :class="$style['tools__tool']"
            :sort="filters.state.sort"
            :is-filters-active="isFiltersActive"
            :active-filters-count="activeFiltersCount"
            :show-export-button="showExportButton"
            :is-exporting="isExporting"
            :hide-sort="hideSort"
            :show-global-search="showGlobalSearch"
            @sort="onSort"
            @export="$emit('export')"
            @toggleFilter="toggleFilter"
        ></BaseToolsSort>

        <div :class="$style['tools__anchor']">
            <transition name="animation-fadedown">
                <div :class="$style['tools__panel']" v-show="toggleFilterStatus">
                    <VFilter ref="vfilter" :filters="filters" @applied="toggleFilterStatus = false"></VFilter>
                </div>
            </transition>
        </div>

        <AppliedFilterChips :chips="appliedChips" @remove="onChipRemove" @reset="onChipsReset"></AppliedFilterChips>

        <template v-if="showQuickFilters">
            <RequestQuickFilters
                :active-scope="activeScope"
                :counts="scopeCounts"
                :show-unassigned="filters.state.method === 'inbox'"
                @filter-by-scope="onScopeClick"
            />
            <StatsBar
                :stats="stats"
                :visible-statuses="visibleStatuses"
                :show-overdue="showOverdue"
                :active-status="activeStatuses"
                @filter-by-status="onStatusClick"
            />
        </template>
    </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import BaseToolsSearch from './BaseToolsSearch';
import BaseToolsSort from './BaseToolsSort';
import VFilter from '@/views/components/Filter/VFilter';
import AppliedFilterChips from './AppliedFilterChips';
import StatsBar from './StatsBar';
import RequestQuickFilters from './RequestQuickFilters';
import { buildChips, effectiveStatuses, effectiveScope } from '@/js/requestFilters';

@Component({
    components: {
        BaseToolsSearch,
        BaseToolsSort,
        VFilter,
        AppliedFilterChips,
        StatsBar,
        RequestQuickFilters,
    },
})
class BaseTools extends Vue {
    @Prop({ type: Object, required: true }) filters;
    @Prop({ type: Boolean, default: false }) showExportButton;
    @Prop({ type: Boolean, default: false }) isExporting;
    @Prop({ type: Object, default: null }) stats;
    @Prop({ type: Array, default: () => ['0', '1', '2', '3', '4', '5'] }) visibleStatuses;
    @Prop({ type: Boolean, default: true }) showOverdue;
    @Prop({ type: Object, default: null }) scopeCounts;
    @Prop({ type: Boolean, default: false }) showQuickFilters;
    @Prop({ type: Boolean, default: false }) hideSort;
    @Prop({ type: Boolean, default: false }) showGlobalSearch;

    toggleFilterStatus = false;
    localSearch = '';

    get appliedChips() {
        return buildChips(this.filters.state, { statusBarVisible: this.showQuickFilters });
    }

    get activeFiltersCount() {
        return this.appliedChips.length;
    }

    get isFiltersActive() {
        return this.appliedChips.length > 0;
    }

    get activeStatuses() {
        return effectiveStatuses(this.filters.state);
    }

    get activeScope() {
        return effectiveScope(this.filters.state);
    }

    onSearchSubmit(value) {
        this.filters.setSearch(value);
    }

    onSort(sort) {
        this.filters.setSort(sort);
    }

    onScopeClick(scope) {
        this.filters.setScope(scope);
    }

    onStatusClick(status) {
        if (status === null) {
            this.filters.clearStatuses();
        } else {
            this.filters.toggleStatus(status);
        }
    }

    onChipRemove(name) {
        this.filters.removePanelFilter(name);
    }

    onChipsReset() {
        this.filters.resetAll();
    }

    toggleFilter() {
        this.toggleFilterStatus = !this.toggleFilterStatus;
        if (this.toggleFilterStatus) {
            const vfilter = this.$refs.vfilter;
            if (vfilter && typeof vfilter.syncFromState === 'function') vfilter.syncFromState();
        }
    }

    clearLocalSearch() {
        this.localSearch = '';
    }

    @Watch('$route.params.method')
    watchRouteParamsMethod() {
        this.toggleFilterStatus = false;
        this.localSearch = '';
    }

    created() {
        this.$bus.on('tools:clear', this.clearLocalSearch);
    }
    beforeDestroy() {
        this.$bus.off('tools:clear', this.clearLocalSearch);
    }
}

export default BaseTools;
</script>
<style lang="scss" module>
.tools {
    width: 100%;
    height: 100%;
    position: relative;

    &__row {
        display: flex;
        align-items: center;
        gap: 12px;
        padding-bottom: 12px;
    }

    &__search {
        flex: 1 1 auto;
    }

    &__tool {
        padding-bottom: 10px;
    }

    &__anchor {
        position: relative;
        height: 0;
    }

    &__panel {
        position: absolute;
        top: 2px;
        left: 0;
        z-index: $layer-dropdown;
        width: 720px;
        max-width: 100%;
    }
}
</style>
